import axios from 'axios'
import router from '../router'
import Mock from 'mockjs'

//编译环境使用mock数据
/*if (process.env.NODE_ENV != 'development') {

  Mock.mock('weixin/user/index/getInformation.action', {
    'list|1-30': [{
      'id|+1': 1,
      'img': Mock.Random.dataImage('40x40', 'joubn'),
      'info': Mock.Random.csentence(20, 30),
      'datetime': Mock.Random.date('yyyy-MM-dd H:m:s')

    }]
  });
}*/
//添加一个响应拦截器
axios.interceptors.response.use(function(res){
  if(res.data.rCode=='noLogin'){
    router.replace({path:'/login'})
    return null;
  }
  return res;
},function(err){
  //Do something with response error
  return Promise.reject(error);
})

/**
 * 字符串拼接
 * @param info 要拼接的对象
 * @param type 是否是需要？拼接
 */
let stringJoin;
stringJoin = (info, type) => {
  let headerString = '';
  if (!info) {
    return '';
  }
  Object.keys(info).map((data, index) => {
    if (index === 0 && type) {
      headerString += '?' + data + '=' + info[data]
    } else {
      headerString += '&' + data + '=' + info[data]
    }
  });
  return headerString
};



/**
 * 核销列表接口
 */
var writeOffList = (data) => axios.get( 'back/commodityCard/writeOffList',{params:data})

/**
 * 核销按钮接口
 *cardUserId	是	long	卡券购买记录id
 */
var writeOffCard = (data) => axios.get( 'back/commodityCard/writeOffCard',{params:data})

/**
 * 核销查询接口
 *cardUserCardNo	是	string	核销id
 */
var findWriteOffCard = (data) => axios.get( 'back/commodityCard/findWriteOffCard',{params:data})

/**
 * 新增话题接口
 *conversationContent	是	String	话题内容
 conversationSpendTime	是	Date	发送时间
 doctorConversationService	是	数组	话题多对多表的
 */
var insertConversation = (data) => axios.post( 'back/conversation/insertConversation',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 编辑话题接口
 *conversationContent	是	String	话题内容
 conversationId	是	Long	话题id
 doctorConversationService	是	数组	话题多对多表的
 conversationContent	是	String	话题内容
 */
var editConversation = (data) => axios.post( 'back/conversation/editConversation',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 内容分类是否显示接口
 * contentTypeId	是	long	内容分类id
 contentTypeIsShow	是	int	内容分类是否显示
 */
var setContentTypeShow = (contentTypeId,state) => axios.get( 'back/contentType/setContentTypeShow',{params:{contentTypeId:contentTypeId,state:state}})

/**
 * 话题 医生模糊查询
 * DoctorName	否	String
 */
var FindDoctorName=(DoctorName)=>axios.get('back/conversation/FindDoctorName',{params:{DoctorName:DoctorName}})

/**
 * 检查内容分类名称是否重复接口
 * contentTypeName	是	string	内容分类名称
 */
var checkContentTypeName=(contentTypeName)=>axios.get('back/contentType/checkContentTypeName',{params:{contentTypeName:contentTypeName}})

/**
 * 内容分类置顶号接口
 *contentTypeId	是	long	内容分类id
 topId	是	int	置顶号
 */
var setContentTypePostion = (data) => axios.post( 'back/contentType/setContentTypePostion',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})


/**
 * 内容分类批量删除接口
 *contentTypeId	是	long	删除内容分类id
 */
var delContentType = (data) => axios.post( 'back/contentType/delContentType',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 内容分类编辑接口
 * json	是	JSONObject	JSONObject
 contentTypeId	是	long	内容分类id
 contentTypeName	是	string	内容分类名称
 contentTypeIsShow	是	int	内容分类是否显示
 contentTypePostion	是	int	内容分类置顶号
 contentTypeDetail	是	string	内容分类详情
 */
var editContentType = (data) => axios.post( 'back/contentType/editContentType',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 新增内容分类接口
 * json	是	JSONObject	JSONObject
 contentTypeName	是	string	内容分类名称
 contentTypePostion	否	int	内容分类置顶号
 contentTypeDetail	是	string	内容分类详情
 */
var addContentType = (data) => axios.post( 'back/contentType/addContentType',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 内容分类详情接口
 * contentTypeId	是	long	内容分类id
 */

var contentTypeDetail = (contentTypeId) => axios.get( 'back/contentType/contentTypeDetail',{params:{contentTypeId:contentTypeId}})


/**
 * 内容分类列表接口
 */

var contentTypeList = (pageIndex,pageSize) => axios.get( 'back/contentType/contentTypeList',{params:{pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 内容添加接口
 * json	是	JSONObject	json
 contentTitle	string	内容标题
 contentImg	string	内容图片
 contentCover	string	内容封面图片
 contentType	Long	内容分类id
 contentShareNum	int	分享次数
 contentZanNum	int	点赞次数
 contentShareBaseNum	int	分享基数
 contentZanBaseNum	int	点赞基数
 contentAbstract	int	内容摘要
 contentPrice	int	内容价格
 contentDetail	int	内容详情
 */
var addContent = (data) => axios.post( 'back/content/addContent',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})


/**
 * 内容详情接口
 contentId	是	Long	内容id
 */


var contentDetail = (contentId,currentPage, pageSize) => axios.get( 'back/content/contentDetail',{params:{contentId:contentId,pageIndex:currentPage,pageSize:pageSize}})


/*xiugai*/
/**
 * 检查科室名称是否重复接口
 departmentName	是	string	科室名称
 departmentType	是	int	科室类型 1答疑科室 2 预约科室
 */

var checkDepartmentName = (departmentName,departmentType) => axios.get( 'back/department/checkDepartmentName',{params:{departmentName:departmentName,departmentType:departmentType}})



/**
 * 科室置顶功能接口
 * departmentId	是	long	删除科室id
 */


var setDepartmentPostion = (data) => axios.post( 'back/department/setDepartmentPostion',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})


/**
 * 批量删除科室接口
 * departmentId	是	long	删除科室id
 */

var delDepartment = (data) => axios.post( 'back/department/delDepartment',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 编辑科室接口
 * departmentName	是	string	科室名称
 departmentShow	是	int	科室是否显示
 departmentType	是	int	科室类型
 departmentIcon	是	string	科室图标
 departmentDetail	是	string	科室详情
 */

var editDepartment = (data) => axios.post( 'back/department/editDepartment',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 拉黑与取消拉黑
 * @param id
 * @param isBlack
 * @returns {AxiosPromise}
 */

var changeBlackList=(userId) => axios.get( 'back/user/isBlack',{params:{userId:userId}})

/**
 *
 * @param userId
 * @returns {AxiosPromise}
 */
var setDoctorPostion=(doctorId,doctorPosition) => axios.get( 'back/doctor/setDoctorPostion',{params:{doctorId:doctorId,doctorPosition:doctorPosition}})


var setActivityDoctorPostion=(doctorActivityId,activityDoctorPosition) => axios.get( 'back/activityDoctor/setActivityDoctorPostion',{params:{doctorActivityId:doctorActivityId,activityDoctorPosition:activityDoctorPosition}})

/**
 * 新增科室接口
 *  departmentName	是	string	科室名称
 departmentShow	是	int	科室是否显示
 departmentType	是	int	科室类型
 departmentIcon	是	string	科室图标
 departmentDetail	是	string	科室详情
 */

var addDepartment = (data) => axios.post( 'back/department/addDepartment',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})


/**
 * 科室详情接口
 *  departmentId	是	long	科室id
 */

var departmentDetail = (departmentId) => axios.get( 'back/department/departmentDetail',{params:{departmentId:departmentId}})


/**
 * 查询科室列表接口
 * departmentType	是	int	科室类型 1答疑科室 2 预约科室
 */

var departmentList = (departmentType,currentPage,pageSize) => axios.get( '/back/department/departmentList',{params:{departmentType:departmentType,pageIndex:currentPage,pageSize:pageSize}})


/**
 * 预约列表接口
 * @param pageIndex 页码
 * userName	否	String	用户名称
 * doctorName	否	String	医生名称
 * reservationType	否	int	1进行中，2已完成，3已取消
 * startTime	否	String	开始时间
 * endTime	否	String	结束时间
 */
var reservationList = (pageIndex,userName,doctorName,reservationType,startTime,endTime) => axios.get( 'back/reservation/reservationList',{params:{pageIndex:pageIndex,userName:userName,doctorName:doctorName,reservationType:reservationType,startTime:startTime,endTime:endTime}})



/**
 * 预约记录详情接口
 * reservationId	是	long	预约记录id
 */

var reservationDetail = (reservationId) => axios.get( 'back/reservation/reservationDetail',{params:{reservationId:reservationId}})



/**
 * 预约记录批量删除接口
 * reservationId	是	long	预约id
 */

var delReservation = (data) => axios.post( 'back/reservation/delReservation',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})


/**
 * 页面列表
 * @param pageIndex 页码
 * @param title 标题
 * @param type 类型
 * @param state 状态
 */


var pageList = (pageIndex, title, type, state) => axios.get( 'back/page/pageList.action',{params:{pageIndex:pageIndex,title:title,type:type,state:state}})

/**
 * 省份
 */
var provinceList = () =>axios.get( 'back/province/provinceList.action')

/**
 * 根据省获取城市
 * @param provinceNo 省编号
 */
var cityList = (provinceNo) =>axios.post('back/province/cityList.action?provinceNo='+provinceNo)

/**
 * 管理员列表
 * @param pageIndex
 * @param keyword
 */


var adminList = (pageIndex,keyword) => axios.get('back/admin/adminList',{params:{pageIndex:pageIndex,keyword:keyword}})

/**
 * 编辑管理员状态
 * @param adminId
 * @param state
 */
var adminEditState=(adminId,state) => axios.post('back/admin/adminEditState',`adminId=${adminId}&stateFlag=${state}`)

/**
 * 管理员详情
 * @param adminId
 */
var adminDetail = (adminId) => axios.post('back/admin/adminDetail',`adminId=${adminId}`)

/**
 * 管理员权限
 * @param admin
 */
var getTree = (adminId) => axios.post('back/permission/getTree',`adminId=${adminId}`)

/**
 * 修改管理员密码
 * @param adminId
 * @param password
 */
var changePwd = (adminId,password) => axios.post('back/admin/changePwd',`adminId=${adminId}&password=${password}`)

/**
 * 修改管理员权限
 * @param adminId
 * @param pids
 */
var changePermission = (adminId,pids) => axios.post('back/admin/changePermission',`adminId=${adminId}&pids=${pids}`)


/**
 * 登录
 * @param account
 * @param password
 */
var login = (account,password) =>axios.post('back/admin/login.action',JSON.stringify({account:account,password:password}),{headers:{'Content-Type':'application/json'}})

/**
 * 退出
 * @param account
 * @param password
 */
var loginout = (account,password) =>axios.get( 'back/admin/loginout.action')

/**
 * 退出登录
 * @param data
 * @returns {AxiosPromise}
 */
var toLoginOut = (data) =>axios.post('back/admin/loginout',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 管理员新增
 * @param adminName
 * @param adminPhone
 * @param adminAccount
 * @param adminPassword
 * @param adminType
 * @param adminStoreId
 */
var adminAdd = (data) =>axios.post( 'back/admin/addAdmin.action',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 管理员编辑
 * @param adminId
 * @param adminName
 * @param adminPhone
 * @param adminAccount
 * @param adminType
 * @param adminStoreId
 */
var adminEdit = (adminId,adminName,adminPhone,adminAccount,adminType,adminStoreId) =>axios.post( 'back/admin/adminEdit.action',`adminId=${adminId}&adminName=${adminName}&adminPhone=${adminPhone}&adminAccount=${adminAccount}&adminType=${adminType}&adminStoreId=${adminStoreId}`)

/**
 * 商品分类列表
 * @param commodityTypeType
 * @param commodityTypeName
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */

var commodityTypeList=(commodityTypeType,commodityTypeName,pageIndex,pageSize)=>axios.get('back/commodity/type/commodityTypeList',{params:{commodityTypeType:commodityTypeType,commodityTypeName:commodityTypeName,pageIndex:pageIndex,pageSize:pageSize}})


/**
 * 入驻商列表（搜索）
 * @param storeName
 * @param storeTel
 * @param startTime
 * @param endTime
 * @param storeState
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var findStoreList=(storeName,storeTel,startTime,endTime,storeState,pageIndex,pageSize)=>axios.get('back/store/findStoreList',{params:{storeName:storeName,storeTel:storeTel,startTime:startTime,endTime:endTime,storeState:storeState,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 查看入驻商详情
 * @param storeId
 * @returns {AxiosPromise}
 */
var showDetail=(storeId)=>axios.get('back/store/showDetail',{params:{storeId:storeId}})
/**
 * 提交入驻商编辑
 * @param data
 * @returns {AxiosPromise}
 */
var commitStorerEdit=(data)=>axios.post('back/store/commitStorerEdit',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 添加入驻商
 * @param data
 * @returns {AxiosPromise}
 */
var addStorer=(data)=>axios.post('back/store/addStorer',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 商品分类修改
 * @param data
 * @returns {AxiosPromise}
 */
var editCommodityType=(data)=>axios.post('back/commodity/type/editCommodityType',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 商品分类删除
 * @param id
 * @returns {AxiosPromise}
 */
var delCommodityType=(data)=>axios.post('back/commodity/type/delCommodityType',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})


/**
 * 商品分类详情
 * @param commodityTypeId
 * @returns {AxiosPromise}
 */
var detailCommodityType=(commodityTypeKeyId)=>axios.get('back/commodity/type/detailCommodityType',{params:{commodityTypeKeyId:commodityTypeKeyId}})

/**
 * 设置商品分类置顶
 * @param data
 * @returns {AxiosPromise}
 */
var setCommodityTypeTop=(data)=>axios.post('back/commodity/type/setCommodityTypeTop',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 专题列表显示（搜索）
 * @param data
 * @returns {AxiosPromise}
 */
var findTopic=(topicTitle,pageIndex,pageSize)=>axios.get('back/topic/findTopic',{params:{topicTitle:topicTitle,pageIndex:pageIndex,pageSize:pageSize}})
/**
 * 查看专题详情
 * @param topicId
 * @returns {AxiosPromise}
 */
var toTopicEdit=(topicId)=>axios.get('back/topic/toTopicEdit',{params:{topicId:topicId}})

/**
 * 编辑提交专题
 * @param data
 * @returns {AxiosPromise}
 */
var commitTopicEdit=(data)=>axios.post('back/topic/commitTopicEdit',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 删除专题
 * @param topicId
 * @returns {AxiosPromise}
 */
var delTopic=(data)=>axios.post('back/topic/delTopic',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 修改专题是否推荐页显示
 * @param topicId
 * @param topicIsRecommend
 * @returns {AxiosPromise}
 */
var  changeRecommend=(topicId,topicIsRecommend)=>axios.get('back/topic/changeRecommend',{params:{topicId:topicId,topicIsRecommend:topicIsRecommend}})
/**
 * 新增专题
 * @param data
 * @returns {AxiosPromise}
 */
var addTopic=(data)=>axios.post('back/topic/addTopic',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 商品分类修改
 * @param data
 * @returns {AxiosPromise}
 */
var editCommodityType=(data)=>axios.post('back/commodity/type/editCommodityType',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 专题修改是否上线
 * @param topicId
 * @param topicIsOnline
 * @returns {AxiosPromise}
 */
var changeIsOnline=(topicId,topicIsOnline)=>axios.get('back/topic/changeIsOnline',{params:{topicId:topicId,topicIsOnline:topicIsOnline}})
/**
 * 商品分类新增
 * @param data
 * @returns {AxiosPromise}
 */
var addCommodityType=(data)=>axios.post('back/commodity/type/addCommodityType',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})



/**
 * 平台自营/我的商品列表
 * @param storeId
 * @param commodityTypeId
 * @param salePriceMin
 * @param salePriceMax
 * @param name
 * @param itemNo
 * @param reviewState
 * @param status
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var myCommodityList=(commodityTypeId,salePriceMin, salePriceMax, name, itemNo , reviewState, status, pageIndex, pageSize)=>axios.get('back/commodity/myCommodityList',{params:{commodityTypeId:commodityTypeId,salePriceMin:salePriceMin,salePriceMax:salePriceMax,name:name,itemNo:itemNo,reviewState:reviewState,status:status,pageIndex:pageIndex,pageSize:pageSize}})

/**
 *入驻商品列表
 * @param commodityTypeId
 * @param salePriceMin
 * @param salePriceMax
 * @param name
 * @param itemNo
 * @param reviewState
 * @param status
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var commodityList=(commodityTypeId,salePriceMin, salePriceMax, name, itemNo , reviewState, status, pageIndex, pageSize)=>axios.get('back/commodity/commodityList',{params:{commodityTypeId:commodityTypeId,salePriceMin:salePriceMin,salePriceMax:salePriceMax,name:name,itemNo:itemNo,reviewState:reviewState,status:status,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 商品删除
 * @param data
 * @returns {AxiosPromise}
 */
var delCommodity=(data)=>axios.post('back/commodity/delCommodity',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 商品修改
 * @param data
 * @returns {AxiosPromise}
 */
var editCommodity=(data)=>axios.post('back/commodity/editCommodity',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 批量推荐
 * @param data
 * @returns {AxiosPromise}
 */
var setRecommend=(data)=>axios.post('back/commodity/setRecommend',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 推荐
 * @param data
 * @returns {AxiosPromise}
 */
var setRecommendById=(commodityId,commodityStoreRec)=>axios.get('back/commodity/setRecommendById',{params:{commodityId:commodityId,commodityStoreRec:commodityStoreRec}})
/**
 * 批量上架
 * @param data
 * @returns {AxiosPromise}
 */
var setBatchCommodityDrop=(data)=>axios.post('back/commodity/setBatchCommodityDrop',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})


/**
 * 所有商品类别
 * @param commodityTypeId
 * @returns {AxiosPromise}
 */
var allCommodityType=()=>axios.get('back/commodity/type/allCommodityType',{params:{}})

/**
 * 设置商品置顶
 * @param data
 * @returns {AxiosPromise}
 */
var setCommodityTop=(data)=>axios.post('back/commodity/setCommodityTop',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})


/**
 * 商品评论删除
 * @param id
 * @returns {AxiosPromise}
 */
var delComment=(data)=>axios.post('back/comment/delComment',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 商品评论列表
 * @param id
 * @returns {AxiosPromise}
 */
var getCommentList=(commentLevel,commentUserName,commodityName,pageIndex,pageSize)=>axios.get('back/comment/commentList',{params:{commentLevel:commentLevel,userName:commentUserName,commodityName:commodityName,pageIndex:pageIndex,pageSize:pageSize}})



/**
 * 活动订单列表
 * @param onlineOrderNo
 * @param onlineOrderAccount
 * @param onlineOrderStatus
 * @param onlineOrderType
 * @param dateBegin
 * @param dateEnd
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var showActivityOrder=(onlineOrderNo,onlineOrderAccount,onlineOrderStatus,onlineOrderType,dateBegin,dateEnd,pageIndex,pageSize)=>axios.get('back/activityOrder/list',{params:{onlineOrderNo:onlineOrderNo,onlineOrderAccount:onlineOrderAccount,onlineOrderStatus:onlineOrderStatus,onlineOrderType:onlineOrderType,dateBegin:dateBegin,dateEnd:dateEnd,pageIndex:pageIndex,pageSize:pageSize}})
/**
 * 文章列表
 * @param articleName
 * @param currentPage
 * @param pageSize
 * @returns {AxiosPromise}
 */
var showAtcBysearchOrNot =(articleName,currentPage,pageSize)=>axios.get('back/article/showArticleList',{params:{articleName:articleName,pageIndex:currentPage,pageSize:pageSize}})
/**
 * 活动订单详情
 * @param onlineOrderId
 * @returns {AxiosPromise}
 */
var showOrderDetail = (onlineOrderId)=>axios.get('back/activityOrder/showDetail',{params:{onlineOrderId:onlineOrderId}})
/**
 * 添加文章
 * @param data
 * @returns {AxiosPromise}
 */
var articleAdd = (data)=>axios.post('back/article/addArticle',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 批量删除活动订单
 */
var batchDelete=(data)=>axios.post('back/activityOrder/batchDelete',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 活动列表
 * @param activityType
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var findAssistsActivity=(activityType,pageIndex,pageSize)=>axios.get('back/assistsActivity/findAssistsActivity',{params:{activityType:activityType,pageIndex:pageIndex,pageSize:pageSize}})
/**
 * 显示banner列表
 * @param banner_type
 * @returns {AxiosPromise}
 */
var findBanner=(banner_type,bannerStoreId,pageIndex,pageSize)=>axios.get('back/banner/findBanner',{params:{banner_type:banner_type,bannerStoreId:bannerStoreId,pageIndex:pageIndex,pageSize:pageSize}})


/**
 * 进入banner编辑页面
 * @param bannerId
 * @returns {AxiosPromise}
 */
var toEditBanner=(bannerId)=>axios.get('back/banner/toEditBanner',{params:{bannerId:bannerId}})

/**
 * banner提交编辑
 * @param data
 * @returns {AxiosPromise}
 */
var commitEditBanner=(data)=>axios.post('back/banner/commitEditBanner',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * banner添加
 * @param data
 * @returns {AxiosPromise}
 */
var addBanner=(data)=>axios.post('back/banner/addBanner',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 删除轮播图（批量删除）
 * @param data
 * @returns {AxiosPromise}
 */
var  delBanner=(data)=>axios.post('back/banner/delBanner',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 修改banner显示状态
 * @param bannerId
 * @param bannerStatus
 * @returns {AxiosPromise}
 */
var changeBannerStatus=(bannerId,bannerStatus)=>axios.get('back/banner/changeBannerStatus',{params:{bannerId:bannerId,bannerStatus:bannerStatus}})
/**
 * 评论详细
 * @param commentId
 * @returns {AxiosPromise}
 */
var detailComment=(commentId)=>axios.get('back/comment/detailComment',{params:{commentId:commentId}})

/**
 * 新增评论
 * @param data
 * @returns {AxiosPromise}
 */
var addComment=(data)=>axios.post('back/comment/addComment',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 商品全部查询（模糊）
 * @returns {AxiosPromise}
 */
var searchCommodityList=(data)=>axios.get('back/commodity/searchCommodityList',{params:data})

/**
 * 添加回复
 * @param data
 * @returns {AxiosPromise}
 */
var addReply=(data)=>axios.post('back/comment/addReply',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 库存预警列表
 * @param storeId
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var inventoryWarningList=(pageIndex,pageSize)=>axios.get('back/inventoryWarning/inventoryWarningList',{params:{pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 取消预警（批量）
 * @param data
 * @returns {AxiosPromise}
 */
var cancelWarning=(data)=>axios.post('back/inventoryWarning/cancelWarning',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 运费模板列表
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var freightTemplateList=(pageIndex,pageSize)=>axios.get('back/freight/freightTemplateList',{params:{pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 查询所有运费模板
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var freightTemplateAllList=()=>axios.get('back/freight/freightTemplateAllList',{params:{}})

/**
 * 删除运费模板(批量)
 * @param data
 * @returns {AxiosPromise}
 */
var delFreightTemplate=(data)=>axios.post('back/freight/delFreightTemplate',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 添加运费模板
 * @param data
 * @returns {AxiosPromise}
 */
var addFreightTemplate=(data)=>axios.post('back/freight/addFreightTemplate',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 修改运费模板
 * @param data
 * @returns {AxiosPromise}
 */
var editFreightTemplate=(data)=>axios.post('back/freight/editFreightTemplate',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 *运费模板详情
 * @param data
 * @returns {AxiosPromise}
 */
var detailFreightTemplate=(templateId)=>axios.get('back/freight/detailFreightTemplate',{params:{templateId:templateId}})

/**
 * 跳转订单发货信息接口
 * @returns {AxiosPromise}
 */
/**客户列表
 * todo 参数未全
 * @param userNickname
 * @param userTel
 * @param currentPage
 * @param pageSize
 * @returns {AxiosPromise}
 */
var userListNew=(doctorRealname,userNickname,userType,userTel,dateBegin,dateEnd,authenticationAddress,babyType,babyStart,babyEnd,currentPage,pageSize)=>axios.get('back/user/userListNew',{params:{start:dateBegin,userType:userType,end:dateEnd,pageIndex:currentPage,pageSize:pageSize,userNickname:userNickname,userTel:userTel,authenticationAddress:authenticationAddress,babyType:babyType,babyStart:babyStart,babyEnd:babyEnd,doctorRealname:doctorRealname}})
/**
 * 客户详情
 * @param userId
 * @param currentPage
 * @param pageSize
 * @returns {AxiosPromise}
 */
var showUserDetail=(userId,selectType,currentPage,pageSize)=>axios.get('back/user/userDetail',{params:{userId:userId,selectType:selectType,pageIndex:currentPage,pageSize:pageSize}})
/**
 * 客户详情 用户答疑列表
 * @param userId
 * @param currentPage
 * @param pageSize
 * @returns {AxiosPromise}
 */
var showUserDetailAnswer=(userId,selectType,currentPage,pageSize)=>axios.get('back/user/userDetail',{params:{userId:userId,selectType:selectType,pageIndex:currentPage,pageSize:pageSize}})
/**
 * 提交编辑
 * @param data
 * @returns {AxiosPromise}
 */
var updateArticle = (data)=>axios.post('back/article/update',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 文章详情
 * @param articleId
 * @returns {AxiosPromise}
 */
var toUpdateArticle =(articleId)=>axios.get('back/article/toEdit',{params:{articleId:articleId}})
/**
 * 删除文章
 * @param data
 * @returns {AxiosPromise}
 */
var deleteArticles =(data)=>axios.post('back/article/deleteByIds',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 设置文章排序
 * @param sort
 * @returns {AxiosPromise}
 */
var setArticleSort =(sort,articleId)=>axios.get('back/article/setSort',{params:{sortNum:sort,articleId:articleId}})
/**
 * 更改文章首页可见性
 * @param articleId
 * @param articleIsSee
 * @returns {AxiosPromise}
 */
var changeArticleIsSee=(articleId,articleIsSee)=>axios.get('back/article/changeIsSee',{params:{articleIsSee:articleIsSee,articleId:articleId}})

/**
 * 订单列表
 * @param flg
 * @param onlineOrderNo
 * @param onlineOrderAccount
 * @param onlineOrderStatus
 * @param onlineOrderType
 * @returns {AxiosPromise}
 */
var onlineOrderList = (data) => axios.get( 'back/order/onlineOrderList',{params:data})
/**
 * 订单详情
 * @param orderId
 * @returns {AxiosPromise}
 */
var orderDetail=(orderId)=>axios.get('back/order/orderDetail',{params:{orderId:orderId}})
/**
 * 修改发货单
 * @param data
 * @returns {AxiosPromise}
 */
var updateDelivery=(data)=>axios.post('back/delivery/updateDelivery',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 平台流水明细列表
 * @param storeId
 * @param type
 * @param priceMin
 * @param priceMax
 * @param timeMax
 * @param timeMin
 * @returns {AxiosPromise}
 */
var fundsList=(storeId,timeSort,priceSort,type,priceMin,priceMax,timeMax,timeMin,pageIndex,pageSize)=>axios.get('back/funds/fundsList',{params:{storeId:storeId,timeSort:timeSort,priceSort:priceSort,type:type,priceMin:priceMin,priceMax:priceMax,timeMax:timeMax,timeMin:timeMin,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 跳转订单发货信息接口
 * @param orderId
 * @returns {AxiosPromise}
 */
var gotoDeliverOrder=(orderId)=>axios.get('back/order/gotoDeliveryOrder',{params:{orderId:orderId}})
/**
 * 订单发货
 * @param data
 * @returns {AxiosPromise}
 */
var deliverOrder=(data)=>axios.post('back/order/deliverOrder',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 发货单列表
 * @param storeId
 * @param orderNo
 * @param deliveryNo
 * @param storeName
 * @param companyName
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var deliveryList=(storeId,orderNo,deliveryNo,storeName,companyName,pageIndex,pageSize)=>axios.get('back/delivery/deliveryList',{params:{storeId:storeId,orderNo:orderNo,deliveryNo:deliveryNo,storeName:storeName,companyName:companyName,pageIndex:pageIndex,pageSize:pageSize}})
/**
 * 平台流水明细列表
 * @param storeId
 * @param type
 * @param priceMin
 * @param priceMax
 * @param timeMax
 * @param timeMin
 * @returns {AxiosPromise}
 */
var fundsList=(storeId,timeSort,priceSort,type,priceMin,priceMax,timeMax,timeMin,pageIndex,pageSize)=>axios.get('back/funds/fundsList',{params:{storeId:storeId,timeSort:timeSort,priceSort:priceSort,type:type,priceMin:priceMin,priceMax:priceMax,timeMax:timeMax,timeMin:timeMin,pageIndex:pageIndex,pageSize:pageSize}})


/**
 * 商家结算统计
 * @param storeId
 * @param year
 * @param season
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var statisticsFundsList=(storeId, year,season,pageIndex,pageSize)=>axios.get('back/funds/statisticsFundsList',{params:{storeId:storeId,year:year,season:season,pageIndex:pageIndex,pageSize:pageSize}})
/**
 * 用户详情
 * @param userId
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var doctorActivityDetail = (doctorActivityId,pageIndex,pageSize)=>axios.get('back/activityDoctor/doctorActivityDetail',{params:{doctorActivityId:doctorActivityId,pageIndex:pageIndex,pageSize:pageSize}})
/**
 * 设置活动排序
 * @param activityPostion
 * @param activityId
 * @returns {AxiosPromise}
 */
var changeActivity = (activityPostion,activityId)=>axios.get('back/assistsActivity/changeActivity',{params:{activityId:activityId,activityPostion:activityPostion}})

/**
 * 设置活动上下线
 * @param activityId
 * @param activityType
 * @param activityState
 * @return
 */
var changeActivityState =(data)=>axios.post('back/assistsActivity/changeActivityState',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 *退货退款列表
 * @param storeId
 * @param orderNo
 * @param status
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var refundInfoList=(storeId,orderNo,status,pageIndex,pageSize)=>axios.get('back/refundInfo/refundInfoList',{params:{storeId:storeId,orderNo:orderNo,status:status,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 新增商品新增
 */
var addCommodity =(data)=>axios.post('back/commodity/addCommodity',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})


/**
 * 商品详情
 */
var detailCommodity =(commodityId)=>axios.get('back/commodity/detailCommodity',{params:{commodityId:commodityId}})








/**
 * 添加活动
 * @param jsonObject
 * @param session
 * @return
 */
var addActivity =(data)=>axios.post('back/assistsActivity/addActivity',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 获取商品信息
 * @param session
 * @param name
 * @return
 * @throws Exception
 */
var findCommoAndStock = (commodityId)=>axios.get('back/commodity/findCommoAndStock',{params:{commodityId:commodityId}})
/**
 * 活动详情
 * @param activityId
 * @returns {AxiosPromise}
 */
var toEditActivity = (activityId)=>axios.get('back/assistsActivity/toEditActivity',{params:{activityId:activityId}})
/**
 * 商店编辑
 * @param storeId
 * @returns {AxiosPromise}
 */
var toEditStore = (storeId)=>axios.get('back/store/toEditStore',{params:{storeId:storeId}})
/**
 * 商铺
 * @param data
 * @returns {AxiosPromise}
 */
var commitStoreEdit= (data)=>axios.post('back/store/commitEditStore',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 查询所有角色
 * @returns {AxiosPromise}
 */
var roleAll=(adminId)=>axios.get('back/admin/role/roleAll',{params:{adminId:adminId}})
/**
 * 管理员列表
 * @param account
 * @param name
 * @returns {AxiosPromise}
 */
var adminManagerList=(account,name,pageIndex,pageSize,storeId)=>axios.get('back/admin/adminList',{params:{account:account,name:name,pageIndex:pageIndex,pageSize:pageSize,storeId:storeId}})
/**
 * 管理员详情
 * @param adminId
 * @returns {AxiosPromise}
 */
var adminManagerDetail=(adminId)=>axios.get('back/admin/adminDetail',{params:{adminId:adminId}})
/**
 * 管理员编辑
 * @param data
 * @returns {AxiosPromise}
 */
var editAdmin = (data)=>axios.post('back/admin/editAdmin',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 冻结（删除）管理员
 * @param adminId
 * @param state
 * @returns {AxiosPromise}
 */
var freezeAdmin = (adminId,state)=>axios.get('back/admin/freezeAdmin',{params:{adminId:adminId,state:state}})

/**
 * 操作记录列表
 * @param pageIndex
 * @param startTime
 * @param endTime
 * @param keyWord
 * @return
 * @throws Exception
 */
var operationList = (pageIndex,pageSize,startTime,endTime,adminId)=>axios.get('back/admin/operation/operationList',{params:{pageIndex:pageIndex,pageSize:pageSize,startTime:startTime,endTime:endTime,adminId:adminId}})
/**
 * 管理员列表
 * @param adminId
 * @param state
 * @returns {AxiosPromise}
 */
var opAdminList = ()=>axios.get('back/admin/operation/adminList')
/**
 *
 *入驻商订单列表(搜索)
 * @returns {AxiosPromise}
 */
var searchOrder=(storeName,orderAccount,onlineOrderNo,onlineOrderStatus,pageIndex,pageSize)=>axios.get('back/order/searchOrder',{params:{storeName:storeName,orderAccount:orderAccount,onlineOrderNo:onlineOrderNo,onlineOrderStatus:onlineOrderStatus,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 首页信息
 * @returns {AxiosPromise}
 */
var indexdetail=()=>axios.get('back/index/indexInfo',{params:{}})


/**
 * 营收统计
 * @param storeId
 * @returns {AxiosPromise}
 */
var RevenueStatistics=(storeId)=>axios.get('back/funds/RevenueStatistics',{params:{storeId:storeId}})

/**
 * 修改服务类订单的发货状态
 * @returns {AxiosPromise}
 */
var changeOrderStatus=(orderId)=>axios.get('back/order/changeOrderStatus',{params:{orderId:orderId}})

/**
 * 跳转退款详情页面
 * @param refundInfoId
 * @returns {AxiosPromise}
 */
var refundInfoDetail=(refundInfoId)=>axios.get('back/refundInfo/refundInfoDetail',{params:{refundInfoId:refundInfoId}})

/**
 * 设置商铺的暂停营业还是继续营业
 * @returns {AxiosPromise}
 */
var changeStoreState=(storeId,storeState)=>axios.get('back/store/changeStoreState',{params:{storeId:storeId,storeState:storeState}})

/**
 * 删除活动
 * @param activityId
 * @returns {AxiosPromise}
 */
var delBatchActivity=(data)=>axios.post('back/assistsActivity/delBatchActivity',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 提交编辑活动
 * @param data
 * @returns {AxiosPromise}
 */
var commitEditActivity=(data) =>axios.post('back/assistsActivity/commitEditActivity',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 专题管理排序修改
 * @param topicId
 * @param topicPostion
 * @returns {AxiosPromise}
 */
var  changeTopicPostion=(topicId,topicPostion)=>axios.get('back/topic/changeTopicPostion',{params:{topicId:topicId,topicPostion:topicPostion}})

/**
 * 判断是否是唯一店铺名
 * @param storeName
 * @returns {AxiosPromise}
 */

var checkOnlyStore=(storeId,storeName)=>axios.get('back/store/checkOnlyStore',{params:{storeId:storeId,storeName:storeName}})


/**
 * 修改banner排序
 * @param bannerId
 * @param bannerStoreId
 * @param bannerRank
 * @param bannerType
 * @returns {AxiosPromise}
 */
var changeBannerRank=(bannerId,bannerStoreId,bannerRank,bannerType)=>axios.get('back/banner/changeBannerRank',{params:{bannerId:bannerId,bannerStoreId:bannerStoreId,bannerRank:bannerRank,bannerType:bannerType}})
/**
 * 图片上传
 * @param file
 * @param fileName
 * @returns {AxiosPromise}
 */
var fileUpload = ()=>axios.post('back/user/fileUp')
/**
 * 设置商品审核状态
 * @param commodityId
 * @param state
 * @returns {AxiosPromise}
 */
var setReviewState = (commodityId,state,reason)=>axios.get('back/commodity/setReviewState',{params:{commodityId:commodityId,state:state,reason:reason}})

/**
 * 查看驳回信息
 * @param commodityId
 * @returns {AxiosPromise}
 */
var selectReason = (commodityId)=>axios.get('back/commodity/selectReason',{params:{commodityId:commodityId}})

/**
 *审核退款
 * @type {AxiosPromise}
 */
var refundInfoAuditing=(data)=>axios.post('back/refundInfo/refundInfoAuditing',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 单项删除活动
 * @param activityId
 * @returns {AxiosPromise}
 */
var delActivity=(activityId)=>axios.get('back/assistsActivity/delActivity',{params:{activityId:activityId}})

/**
 * 权限获取
 * @param data
 * @returns {AxiosPromise}
 */
var myAdminPermissions=(data)=>axios.post('back/admin/permission/myAdminPermissions',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 修改密码
 * @param data
 * @returns {AxiosPromise}
 */
var changePassword = (data)=>axios.post('back/admin/changePassword',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})


/**
 * 列表查询医生
 * @param doctorRealname
 * @param doctorHospital
 * @param doctorPhone
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var findDoctorList=(doctorRealname,doctorHospital,doctorPhone,doctorIsService,pageIndex,pageSize)=>axios.get('back/doctor/findDoctorList',{params:{doctorRealname:doctorRealname,doctorHospital:doctorHospital,doctorPhone:doctorPhone,doctorIsService:doctorIsService,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 查看医生详情
 * @param doctorId
 * @returns {AxiosPromise}
 */
var showDoctorDetail=(doctorId)=>axios.get('back/doctor/showDoctorDetail',{params:{doctorId:doctorId}})

/**
 * 新增医生
 * @param data
 * @returns {AxiosPromise}
 */
var addDoctor=(data)=>axios.post('back/doctor/addDoctor',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 新增医生答疑功能表
 * @param data
 * @returns {AxiosPromise}
 */
var addDoctorAnswer=(data)=>axios.post('back/doctor/addDoctorAnswer',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 新增医生预约功能表
 * @param data
 * @returns {AxiosPromise}
 */
var addDoctorReservation=(data)=>axios.post('back/doctor/addDoctorReservation',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 *医生编辑
 * @param doctorId
 * @returns {AxiosPromise}
 */
var getDepartment=()=>axios.get('back/doctor/getDepartment',{params:{}})

/**
 *医生编辑
 * @param doctorId
 * @returns {AxiosPromise}
 */
var showEditDoctor=(doctorId)=>axios.get('back/doctor/showEditDoctor',{params:{doctorId:doctorId}})

/**
 * 提交医生编辑
 * @param data
 * @returns {AxiosPromise}
 */
var editDoctor=(data)=>axios.post('back/doctor/editDoctor',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 删除医生
 * @param data
 * @returns {AxiosPromise}
 */
var delDoctor=(data)=>axios.post('back/doctor/delDoctor',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 引流列表
 * @param beginTime
 * @param endTime
 * @param doctorName
 * @param hospitalName
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
  //var popularizeList=(beginTime,endTime,doctorName,hospitalName,pageIndex,pageSize)=>axios.get('back/popularize/popularizeList',{params:{doctorName:doctorName,hospitalName:hospitalName,pageSize:pageSize,pageIndex:pageIndex,beginTime:beginTime,endTime:endTime}})

var serviceSettlementList=(doctorName,hospitalName,banner_type,startTime,endTime,pageIndex,pageSize)=>axios.get('back/serviceSettlement/serviceSettlementList',{params:{doctorName:doctorName,doctorHospital:hospitalName,serviceSettlementType:banner_type,startTime:startTime,endTime:endTime,pageSize:pageSize,pageIndex:pageIndex}})

/**
 * 引流删除
 * @param data
 * @returns {AxiosPromise}
 */
var deleteBatchPopularize=(data)=>axios.post('back/popularize/deleteBatchPopularize',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 批量删除稿费
 * @param data
 * @returns {AxiosPromise}
 */
var delPaymentDetail=(data)=>axios.post('back/paymentDetail/delPaymentDetail',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 *费用查看
 * @returns {AxiosPromise}
 */
var findPaymentDetail=(paymentDetailId)=>axios.get('back/paymentDetail/findPaymentDetail',{params:{paymentDetailId:paymentDetailId}})

/**
 * 批量删除服务结算记录（答疑和预约）
 * @param data
 * @returns {AxiosPromise}
 */
var delServiceSettlement=(data)=>axios.post('back/serviceSettlement/delServiceSettlement',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 批量删除咨询记录
 * @param data
 * @returns {AxiosPromise}
 */
var delServiceConsultation=(data)=>axios.post('back/consultation/delServiceConsultation',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 *提现详情
 * @param drawMoneyId
 * @returns {AxiosPromise}
 */
var drawMoneyDetail=(drawMoneyId)=>axios.get('back/drawMoney/drawMoneyDetail',{params:{drawMoneyId:drawMoneyId}})
/**
 * 提现列表
 * @param beginTime
 * @param endTime
 * @param doctorName
 * @param hospitalName
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var drawMoneyList=(time,endTime,doctorName,hospitalName,pageIndex,pageSize)=>axios.get('back/drawMoney/drawMoneyList',{params:{doctorName:doctorName,hospitalName:hospitalName,pageSize:pageSize,pageIndex:pageIndex,time:time,endTime:endTime}})
/**
 * 提现记录删除
 * @param data
 * @returns {AxiosPromise}
 */
var deleteBatchDrawMoney=(data)=>axios.post('back/drawMoney/deleteBatchDrawMoney',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 结算明细列表
 * @returns {AxiosPromise}
 */
var showSettleModulusList=()=>axios.get('back/settleModulus/showSettleModulusList')
/**
 * 修改系数
 * @returns {AxiosPromise}
 */
var updateSettleModulus=(data)=>axios.post('back/settleModulus/updateSettleModulus',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 医生解冻
 * @returns {AxiosPromise}
 */
var cancelDel=(data)=>axios.post('back/doctor/cancelDel',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 获取所有权限
 * @returns {AxiosPromise}
 */
var getPermissions=()=>axios.get('back/admin/permission/getPermissions')

/**
 * 获取当前用户拥有权限
 * @returns {AxiosPromise}
 */
var getMyPermissions=()=>axios.get('back/admin/permission/getMyPermissions')

/**
 * 检验角色名是否已经存在
 * @param data
 * @returns {AxiosPromise}
 */
var checkRname=(data)=>axios.post('back/admin/role/checkRname',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 新增角色
 * @param data
 * @returns {AxiosPromise}
 */
var addRole=(data)=>axios.post('back/admin/role/addRole',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 角色列表
 * @param account
 * @param name
 * @returns {AxiosPromise}
 */
var roleList=(roleName,pageIndex,pageSize)=>axios.get('back/admin/role/roleList',{params:{roleName:roleName,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 角色进入编辑
 * @param data
 * @returns {AxiosPromise}
 */
var getRole = (roleId)=>axios.get('back/admin/role/getRole',{params:{roleId:roleId}})

/**
 * 角色编辑
 * @param data
 * @returns {AxiosPromise}
 */
var updateRole=(data)=>axios.post('back/admin/role/updateRole',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 冻结（删除）角色
 * @param adminId
 * @param state
 * @returns {AxiosPromise}
 */
var frozenRole = (roleId,state)=>axios.get('back/admin/role/frozenRole',{params:{roleId:roleId,state:state}})


/**
 * 设置商品上下架
 * @returns {AxiosPromise}
 */
var setCommodityDrop=(data)=>axios.post('back/commodity/setCommodityDrop',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})



/**
 * 入驻商发货单列表
 * @param storeId
 * @param orderNo
 * @param deliveryNo
 * @param storeName
 * @param companyName
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var deliveryListForStore=(storeId,orderNo,deliveryNo,storeName,companyName,pageIndex,pageSize)=>axios.get('back/delivery/deliveryListForStore',{params:{storeId:storeId,orderNo:orderNo,deliveryNo:deliveryNo,storeName:storeName,companyName:companyName,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 订单详情
 * @param orderId
 * @returns {AxiosPromise}
 */
var deliveryDetail=(deliveryId)=>axios.get('back/delivery/deliveryDetail',{params:{deliveryId:deliveryId}})

/**
 * 调用快递鸟接口
 * @param deliveryId
 * @returns {AxiosPromise}
 */
var kdQuery=(deliveryNo,deliveryLogisticsCompanyName,deliveryExpressNumber)=>axios.get('back/order/kdQuery',{params:{deliveryNo:deliveryNo,deliveryLogisticsCompanyName:deliveryLogisticsCompanyName,deliveryExpressNumber:deliveryExpressNumber}})

/**
 * 校验活动名称
 * @param activityTitle
 * @returns {AxiosPromise}
 */
var checkActivityName=(activityTitle)=>axios.get('back/assistsActivity/checkActivityName',{params:{activityTitle:activityTitle}})
/**
 *校验banner名称
 * @param bannerName
 * @returns {AxiosPromise}
 */
var checkBannerName=(bannerName)=>axios.get('back/banner/checkBannerName',{params:{bannerName:bannerName}})
/**
 * 校验专题名称
 * @param topicTitle
 * @returns {AxiosPromise}
 */
var checkTopicName=(topicTitle)=>axios.get('back/topic/checkTopicName',{params:{topicTitle:topicTitle}})
/**
 *校验文章名称
 * @param articleName
 * @returns {AxiosPromise}
 */
var checkArticleName=(articleName)=>axios.get('back/article/checkArticleName',{params:{articleName:articleName}})

/**答疑列表
 * @param userNickname
 * @param userTel
 * @param currentPage
 * @param pageSize
 * @returns {AxiosPromise}
 */
var answerList=(userName,doctorName,departmentId,answerQuestionType,dateBegin,dateEnd,currentPage,pageSize)=>axios.get('back/answer/ListAnswerQuestion',{params:{userName:userName,doctorName:doctorName,departmentId:departmentId,answerQuestionType:answerQuestionType,dateBegin:dateBegin,dateEnd:dateEnd,pageIndex:currentPage,pageSize:pageSize}})

/**
 * 删除答疑
 * @param data
 * @returns {AxiosPromise}
 */
var  deleteAnswer=(answerQuestionId)=>axios.get('back/answer/deleteAnswerQuestionById',{params:{answerQuestionId:answerQuestionId}})
/**
 * 删除答疑（批量删除）
 * @param data
 * @returns {AxiosPromise}
 */
var  deleteAnswers=(data)=>axios.post('back/answer/deleteAnswerQuestionByids',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**答疑部门查找列表
 * @param userNickname
 * @param userTel
 * @param currentPage
 * @param pageSize
 * @returns {AxiosPromise}
 */
var findDepart=()=>axios.get('back/answer/selectDepartment',{params:{}})
/**
 * 显示bannerDoctor列表
 * @param banner_type
 * @returns {AxiosPromise}
 */
var bannerDoctorList=(banner_type,pageIndex,pageSize)=>axios.get('back/bannerDoctor/bannerDoctorList',{params:{bannerDoctorType:banner_type,pageIndex:pageIndex,pageSize:pageSize}})
/**
 * 修改bannerDoctor是否显示
 * @param banner_type
 * @returns {AxiosPromise}
 */
var toEditBannerShowDoctor=(bannerDoctorId,bannerDoctorStatus)=>axios.get('back/bannerDoctor/toEditBannerShowDoctor',{params:{bannerDoctorId:bannerDoctorId,bannerDoctorStatus:bannerDoctorStatus}})
/**
 * 修改BannerDoctorRank排序
 * @param banner_type
 * @returns {AxiosPromise} row.bannerDoctorId,row.bannerRank,row.bannerDoctorType
 */
var changeBannerDoctorRank=(bannerDoctorId,bannerRank,bannerDoctorType)=>axios.get('back/bannerDoctor/changeBannerDoctorRank',{params:{bannerDoctorId:bannerDoctorId,bannerRank:bannerRank,bannerDoctorType:bannerDoctorType}})
/**
 * 删除BannerDoctor轮播图
 * @param data
 * @returns {AxiosPromise}
 */
var  delbannerDoctor=(bannerDoctorId)=>axios.get('back/bannerDoctor/delBanner',{params:{bannerDoctorId:bannerDoctorId}})
/**
 * 显示ListConversation列表
 * @param data
 * @returns {AxiosPromise}
 */
var ListConversation=(pageIndex,pageSize)=>axios.get('back/conversation/ListConversation',{params:{pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 修改话题管理的是否显示
 * @param banner_type
 * @returns {AxiosPromise}
 */
var changeconversationIsShow=(conversationId,conversationIsShow)=>axios.get('back/conversation/IsShowConversation',{params:{conversationId:conversationId,conversationIsShow:conversationIsShow}})
/**
 * 删除话题
 * @param data
 * @returns {AxiosPromise}
 */
var  delConversation=(ConversationId)=>axios.get('back/conversation/deleteConversationById',{params:{ConversationId:ConversationId}})

/**
 * 删除话题（批量删除）
 * @param data
 * @returns {AxiosPromise}
 */
var  delConversationByIds=(data)=>axios.post('back/conversation/deleteConversationByIds',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 显示公告表列表
 * @param pageIndex pageSize
 * @returns {AxiosPromise}
 */
var noticeList=(pageIndex,pageSize)=>axios.get('back/notice/noticeList',{params:{pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 修改公告显示
 * @param bannerDoctorId
 * @param bannerDoctorStatus
 * @returns {AxiosPromise}
 */
var toEditNoticeShowDoctor=(noticeId,noticeIsDisplay)=>axios.get('back/notice/toEditNoticeShowDoctor',{params:{noticeId:noticeId,noticeIsDisplay:noticeIsDisplay}})


/**
 * 改变公告排序值
 * @param noticeId
 * @param noticePosition
 * @returns {AxiosPromise}
 */
var changenoticePosition=(noticeId,noticePosition)=>axios.get('back/notice/changenoticePosition',{params:{noticeId:noticeId,noticePosition:noticePosition}})

/**
 * 删除公告
 * @param noticeId
 * @returns {AxiosPromise}
 */
var  delNotice=(noticeId)=>axios.get('back/notice/delNotice',{params:{noticeId:noticeId}})
/**
 * 显示ListConversation列表
 * @param data
 * @returns {AxiosPromise}
 */
var feedbackList=(pageIndex,pageSize)=>axios.get('back/feedback/feedbackList',{params:{pageIndex:pageIndex,pageSize:pageSize}})
/**
 *
 * @param answerQuestionId
 * @returns {AxiosPromise}
 */
var showAnswerQuestionDetail=(answerQuestionId)=>axios.get('back/answer/showAnswerQuestionDetail',{params:{answerQuestionId:answerQuestionId}})

/**
 * 活动列表显示
 * @param doctorActivityName
 * @param doctorActivityStatus
 * @returns {AxiosPromise}
 */
var doctorActivityList=(doctorActivityName,doctorActivityStatus,pageIndex,pageSize)=>axios.get('back/activityDoctor/doctorActivityList',{params:{doctorActivityName:doctorActivityName,doctorActivityStatus:doctorActivityStatus,pageIndex:pageIndex,pageSize:pageSize}})
/**
 * 删除活动（批量删除）
 * @param data
 * @returns {AxiosPromise}
 */
var  activityDoctorId=(data)=>axios.post('back/activityDoctor/deleteActivityDoctorByIds',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 删除答疑
 * @param data
 * @returns {AxiosPromise}
 */
var  deleteActivityDoctorById=(ActivityDoctorId)=>axios.get('back/activityDoctor/deleteActivityDoctorById',{params:{ActivityDoctorId:ActivityDoctorId}})
/**
 * 新增活动
 * @param data
 * @returns {AxiosPromise}
 */
var insetDoctorActivity = (data)=>axios.post('back/activityDoctor/insetDoctorActivity',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 话题详情
 * @param conversationId
 * @returns {AxiosPromise}
 */
var showConversationDetail = (conversationId)=>axios.get('back/conversation/showConversationDetail',{params:{ConversationId:conversationId}})
/**
 * 编辑活动
 * @param data
 * @returns {AxiosPromise}
 */
var editActivityDoctor = (data)=>axios.post('back/activityDoctor/editActivityDoctor',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * banner活动添加
 * @param data
 * @returns {AxiosPromise}
 */
var addBannerDoctor=(data)=>axios.post('back/bannerDoctor/addBanner',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 话题详情
 * @param conversationId
 * @returns {AxiosPromise}
 */
var BannerDoctorDetail = (bannerDoctorId)=>axios.get('back/bannerDoctor/BannerDoctorDetail',{params:{bannerDoctorId:bannerDoctorId}})

/**
 * banner活动修改提交
 * @param data
 * @returns {AxiosPromise}
 */
var EditBannerDoctor=(data)=>axios.post('back/bannerDoctor/EditBannerDoctor',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 公告添加
 * @param data
 * @returns {AxiosPromise}
 */
var addNotice=(data)=>axios.post('back/notice/addNotice',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 公告详情
 * @param noticeId
 * @returns {AxiosPromise}
 */
var noticeDetail = (noticeId)=>axios.get('back/notice/noticeDetail',{params:{noticeId:noticeId}})

/**
 * 公告更新
 * @param data
 * @returns {AxiosPromise}
 */
var Editnotice=(data)=>axios.post('back/notice/Editnotice',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 *
 * @param answerQuestionId
 * @returns {AxiosPromise}
 */
var feedbackDetail=(feedbackId)=>axios.get('back/feedback/feedbackDetail',{params:{feedbackId:feedbackId}})

/**查找所有内容分类
 * @param userNickname
 * @param userTel
 * @param currentPage
 * @param pageSize
 * @returns {AxiosPromise}
 */
var findAllContentType=()=>axios.get('back/contentType/findAllContentType',{params:{}})
/**查找所有内容分类 发布内容的时候
 * @param userNickname
 * @param userTel
 * @param currentPage
 * @param pageSize
 * @returns {AxiosPromise}
 */
var findAllContentTypeWhenAdd=()=>axios.get('back/contentType/findAllContentTypeWhenAdd',{params:{}})
/**
 * 内容列表展示
 * @param contentTitle
 * @param contentType
 * @param currentPage
 * @param pageSize
 * @returns {AxiosPromise}
 */
var contentList=(contentTitle,contentType,currentPage,pageSize)=>axios.get('back/content/contentList',{params:{contentTitle:contentTitle,contentType:contentType,pageIndex:currentPage,pageSize:pageSize}})
/**
 * 商品套餐列表
 * @param suitName
 * @param currentPage
 * @param pageSize
 * @returns {AxiosPromise}
 */
var suitList=(suitName,currentPage,pageSize)=>axios.get('back/suit/suitList',{params:{suitName:suitName,pageIndex:currentPage,pageSize:pageSize}})
/**
 *
 * 删除套餐
 * @param suitId
 * @returns {AxiosPromise}
 */
var deleteSuit=(suitId)=>axios.get('back/suit/deleteSuit',{params:{suitId:suitId}})
/**
 * 删除评论单个
 * @param data
 * @returns {AxiosPromise}
 */
var  delCommentDoctor=(commentDoctorId)=>axios.get('back/commentDoctor/delCommentDoctor',{params:{commentDoctorId:commentDoctorId}})
/**
 * 删除活动（批量删除）
 * @param data
 * @returns {AxiosPromise}
 */
var  delContent=(data)=>axios.post('back/content/delContent',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * banner活动添加
 * @param data
 * @returns {AxiosPromise}
 */
var addCommentDoctor=(data)=>axios.post('back/commentDoctor/addCommentDoctor',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * banner添加
 * @param data
 * @returns {AxiosPromise}
 */
var addPaymentDetail=(data)=>axios.post('back/paymentDetail/addPaymentDetail',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 更改稿费详情
 * @param data
 * @returns {AxiosPromise}
 */
var updatePaymentDetail=(data)=>axios.post('back/paymentDetail/updatePaymentDetail',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 撤回按钮功能
 * @param paymentDetailId
 * @param paymentDetailOrder
 * @returns {AxiosPromise}
 */
var updatePaymentDetailByBotton=(paymentDetailId,paymentDetailOrder)=>axios.get('back/paymentDetail/updatePaymentDetailByBotton',{params:{paymentDetailId:paymentDetailId,paymentDetailOrder:paymentDetailOrder}})
/**
 * 内容增加
 * @param data
 * @returns {AxiosPromise}
 */
var  addContent=(data)=>axios.post('back/content/addContent',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 修改活动
 * @param data
 * @returns {AxiosPromise}
 */
var editContent = (data)=>axios.post('back/content/editContent',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 修改部门是否显示
 * @param banner_type
 * @returns {AxiosPromise}
 */
var toEditdepartmentShowDoctor=(bannerDoctorId,bannerDoctorStatus)=>axios.get('back/department/toEditdepartmentShowDoctor',{params:{departmentId:bannerDoctorId,departmentShow:bannerDoctorStatus}})

/**
 * 设置卡券排序接口
 * json	是	json	json
 commodityCardId	是	long	卡券主键id
 topId	是	int	排序位置
 */
var CommodityCardRank = (data) => axios.post( 'back/commodityCard/CommodityCardRank',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 卡券删除接口
 * commodityCardId	是	long	卡券主键id
 */
var delCommodityCard = (data) => axios.get( 'back/commodityCard/delCommodityCard',{params:data})

/**
 * 卡券是否推荐接口
 * commodityCardId	是	long	卡券主键id
 */
var cardIsRecommend = (data) => axios.get( 'back/commodityCard/cardIsRecommend',{params:data})

/**
 * 卡券上线/下线接口
 * commodityCardId	是	long	卡券主键id
 */
var cardUpShelve = (data) => axios.get( 'back/commodityCard/cardUpShelve',{params:data})


/**
 * 编辑卡券
 * @param data
 * @returns {AxiosPromise}
 */
var editCommodityCard = (data) => axios.post( 'back/commodityCard/editCommodityCard',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 新增卡券
 * @param data
 * @returns {AxiosPromise}
 */
var addCommodityCard = (data) => axios.post( 'back/commodityCard/addCommodityCard',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 编辑套餐
 * @param data
 * @returns {AxiosPromise}
 */
var editSuit = (data) => axios.post( 'back/suit/editSuit',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 增加套餐
 * @param data
 * @returns {AxiosPromise}
 */
var addSuit = (data) => axios.post( 'back/suit/addSuit',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 套餐上下架
 * @param data
 * @returns {AxiosPromise}
 */
var setOnline = (data) => axios.get( 'back/suit/setOnline',{params:data})
/**
 * 套餐详情
 * @param commodityCardId
 * @returns {AxiosPromise}
 */
var suitDetail = (commoditySuitId) => axios.get( 'back/suit/suitDetail',{params:{suitId:commoditySuitId}})
/**
 *套餐列表的店铺
 * @returns {AxiosPromise}
 */
var findStoreList1 = () => axios.get( 'back/suit/findStoreList',{params:{}})
/**
 * 找到改店铺下的商品
 * @returns {AxiosPromise}
 */
var findCommodityList = (storeId) => axios.get( 'back/suit/findCommodityList',{params:{storeId:storeId}})
/**
 * 卡券去编辑
 * @param consltationId
 * @returns {AxiosPromise}
 */
var toEditCommodityCard = (commodityCardId) => axios.get( 'back/commodityCard/toEditCommodityCard',{params:{commodityCardId:commodityCardId}})
/**
 * 卡券列表接口
 */
var CardListForPlatform = (data) => axios.get( 'back/commodityCard/CardListForPlatform',{params:data})
/**
 * 套餐设置排序值
 * @param data
 * @returns {AxiosPromise}
 */
var setSort = (data) => axios.get( 'back/suit/setSort',{params:data})
/**
 * 咨询费详情
 * @param data
 * @returns {AxiosPromise}
 */
var consultationDetail = (consltationId) => axios.get( 'back/consultation/consultationDetail',{params:{consltationId:consltationId}})
/**
 * 卡券详情接口
 * commodityCardId	是	Long	卡券主键id
 */
var commodityCardDetail = (data) => axios.get( 'back/commodityCard/commodityCardDetail',{params:data})


/**
 *
 * 卡券结算列表接口
 * @returns {AxiosPromise}
 */
var cardSettement = (storeId,year,month,season,pageIndex,pageSize) => axios.get( 'back/commodityCard/cardSettement',{params:{storeId:storeId,year:year,month:month,season:season,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 后台认证妈咪
 * @param data
 * @returns {AxiosPromise}
 */
var addMom = (data)=>axios.post('back/user/addMom',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 后台修改妈咪信息
 * @param data
 * @returns {AxiosPromise}
 */
var editMom = (data)=>axios.post('back/user/editMom',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 设置咨询商品接口
 * @param commodityId
 * @returns {AxiosPromise}
 */
var isConsultation = (commodityId) => axios.get( 'back/commodity/isConsultation',{params:{commodityId:commodityId}})

/**
 * 卡券核销列表主平台
 * @param commodityId
 * @returns {AxiosPromise}
 */
var writeOffListPlatform = (storeId,userName,pageIndex,pageSize) => axios.get( 'back/commodityCard/writeOffListPlatform',{params:{storeId:storeId,userName:userName,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 查询订单提醒人列表
 * @param remindName
 * @param remindPhone
 * @param storeId
 * @param pageIndex
 * @param pageSize
 * @returns {AxiosPromise}
 */
var findemindList =(remindName,remindPhone,storeId,pageIndex,pageSize)=>axios.get( 'back/orderRemind/findemindList',{params:{remindName:remindName,remindPhone:remindPhone,storeId:storeId,pageIndex:pageIndex,pageSize:pageSize}})

/**
 * 查询所有店铺
 * @returns {AxiosPromise}
 */
var showAddRemind=()=>axios.get('back/orderRemind/showAddRemind',{params:{}})

/**
 * 添加订单提醒人
 * @param data
 * @returns {AxiosPromise}
 */
var addRemind=(data)=>axios.post('back/orderRemind/addRemind',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 编辑订单提醒人
 * @param data
 * @returns {AxiosPromise}
 */
var editRemind=(data)=>axios.post('back/orderRemind/editRemind',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})
/**
 * 删除订单提醒人员
 * @param data
 * @returns {AxiosPromise}
 */
var delRemind=(data)=>axios.post('back/orderRemind/delRemind',JSON.stringify(data),{headers:{'Content-Type':'application/json'}})

/**
 * 查询退款结果接口
 * @param refundId
 * @returns {AxiosPromise}
 */
var findRefundResult = (refundId)=> axios.get('back/refundInfo/findRefundResult',{params:{refundId:refundId}})
/**
 * 判断该stock有没有被其他地方用到
 * @param stockId
 */
var checkStock=(stockId)=>axios.get('back/commodity/checkStock',{params:{stockId:stockId}})

export {checkStock,findRefundResult,delRemind,editRemind,addRemind,showAddRemind,findemindList,setActivityDoctorPostion,setDoctorPostion,writeOffListPlatform,editMom,addMom,commodityCardDetail,cardUpShelve,CommodityCardRank,delCommodityCard,cardIsRecommend,CardListForPlatform,writeOffList,writeOffCard,findWriteOffCard,delServiceSettlement,delPaymentDetail,getDepartment,toEditdepartmentShowDoctor,editContent,addContent,delContent,delCommentDoctor,contentDetail,contentList,findAllContentType,addDoctorReservation,addDoctorAnswer,feedbackDetail,Editnotice,noticeDetail,addNotice,doctorActivityDetail,editDepartment,addDepartment,departmentDetail,departmentList,reservationDetail,reservationList,showAnswerQuestionDetail,feedbackList,delNotice,changenoticePosition,toEditNoticeShowDoctor,noticeList,deleteAnswers,deleteAnswer,delConversationByIds,delConversation,changeconversationIsShow,ListConversation,delbannerDoctor,delServiceConsultation,changeBannerDoctorRank,toEditBannerShowDoctor,bannerDoctorList,findDepart,answerList,checkArticleName,checkTopicName,checkBannerName,checkActivityName,updateDelivery,deliveryDetail,deliveryListForStore,setCommodityDrop,updateRole,frozenRole,getMyPermissions,getRole,roleList,addRole,checkRname,getPermissions,cancelDel,updateSettleModulus,showSettleModulusList,deleteBatchDrawMoney,drawMoneyList,drawMoneyDetail,deleteBatchPopularize,serviceSettlementList,delDoctor,editDoctor,showEditDoctor,addDoctor,showDoctorDetail,findDoctorList,selectReason,changePassword,myAdminPermissions,delBatchActivity,setReviewState,fileUpload,changeIsOnline,checkOnlyStore,toLoginOut,changeBannerStatus,changeTopicPostion,changeStoreState,commitEditActivity,delActivity,refundInfoDetail,refundInfoList,addTopic,changeOrderStatus,indexdetail,RevenueStatistics,searchOrder,freightTemplateAllList,detailCommodity,addCommodity,opAdminList,operationList,freezeAdmin,editAdmin,adminManagerDetail,adminManagerList,adminAdd,roleAll,commitStoreEdit,toEditStore,toEditActivity,addActivity,findCommoAndStock,setRecommend,editCommodity,changeActivityState,changeActivity,orderDetail,onlineOrderList,deliverOrder,deliveryList,statisticsFundsList,fundsList,changeArticleIsSee,setArticleSort,updateArticle,deleteArticles,toUpdateArticle,userListNew,gotoDeliverOrder,editFreightTemplate,detailFreightTemplate,addFreightTemplate,delFreightTemplate,freightTemplateList,cancelWarning,inventoryWarningList,  addReply,addComment,searchCommodityList,commodityList,delCommodity,setBatchCommodityDrop,setCommodityTop,detailComment,delComment,getCommentList,articleAdd,findAssistsActivity,batchDelete,allCommodityType,addBanner,commitTopicEdit,delBanner,changeBlackList,commitEditBanner,toEditBanner,findBanner,
  delDepartment,checkDepartmentName,delReservation,setDepartmentPostion,contentTypeList,addContentType,checkContentTypeName,contentTypeDetail,editContentType,delContentType,setContentTypePostion,setContentTypeShow,
  showUserDetail,kdQuery,addPaymentDetail,showUserDetailAnswer,findAllContentTypeWhenAdd,consultationDetail,toEditCommodityCard,setOnline,findStoreList1,findCommodityList,
  editConversation,insertConversation,FindDoctorName,addCommentDoctor,editCommodityCard,suitList,suitDetail,setSort,setRecommendById,findPaymentDetail,updatePaymentDetail,updatePaymentDetailByBotton,
  changeRecommend,delTopic,addCommodityCard,toTopicEdit,findTopic,addStorer,showActivityOrder,showAtcBysearchOrNot,showOrderDetail,myCommodityList,addCommodityType,commitStorerEdit,showDetail,detailCommodityType,delCommodityType,findStoreList,setCommodityTypeTop,editCommodityType,commodityTypeList,pageList,provinceList,cityList,login,loginout,changeBannerRank,refundInfoAuditing,
  doctorActivityList,activityDoctorId,deleteActivityDoctorById,insetDoctorActivity,showConversationDetail,editActivityDoctor,addBannerDoctor,BannerDoctorDetail,EditBannerDoctor,cardSettement,isConsultation
  ,deleteSuit,editSuit,addSuit
}





// WEBPACK FOOTER //
// ./src/service/getData.js